export const handleActivationKey = (callback) => (event) => {
	if (event.key === 'Enter' || event.key === ' ') {
		event.preventDefault();
		callback(event);
	}
};

/** WCAG 2.5.8 — minimum 24×24 CSS px hit target (icon size unchanged). */
export const iconButtonTouchTargetSx = {
	minWidth: 24,
	minHeight: 24,
	boxSizing: 'border-box',
};

/** WCAG 2.4.7 — visible keyboard focus for text/icon controls (e.g. More Info, Select All). */
export const keyboardFocusVisibleSx = {
	'&:focus-visible, &.Mui-focusVisible': {
		outline: '2px solid #3053D3',
		outlineOffset: '2px',
		boxShadow: 'none',
	},
};

export const handleOtpPaste = (onChange, maxLength = 8) => (event) => {
	const pasted = event.clipboardData
		.getData('text')
		.replace(/\D/g, '')
		.slice(0, maxLength);
	if (!pasted) {
		return;
	}
	event.preventDefault();
	onChange(pasted);
};

export const visuallyHiddenSx = {
	position: 'absolute',
	width: '1px',
	height: '1px',
	padding: 0,
	margin: '-1px',
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	whiteSpace: 'nowrap',
	border: 0,
};
